import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireSub = false, ownerOnly = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div style={{ padding: 80, textAlign: "center", color: "var(--text-muted)" }}>Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (ownerOnly && !user.is_owner) return <Navigate to="/dashboard" replace />;
  if (requireSub && !user.has_access) return <Navigate to="/paywall" replace />;
  return children;
}
